import apiEndPoints from '../../apiconstants';
import { api, handleErrorResponse } from '../api';

/** Metadata for a schema from the datamodels API */
export interface DatamodelSchemaMetadata {
  lakehouse_name: string;
  schema_name: string;
  workspace: string | null;
  sql_endpoint: string;
  connector_reference: string | null;
}

/** Single schema from api/v1/datamodels */
export interface DatamodelSchema {
  id: string;
  name: string;
  metadata: DatamodelSchemaMetadata;
}

/** Response data from api/v1/datamodels */
export interface DatamodelsResponseData {
  schemas: DatamodelSchema[];
  count: number;
}

/** Full API response for api/v1/datamodels */
export interface DatamodelsApiResponse {
  status_code: number;
  message: string;
  data: DatamodelsResponseData;
}

/** Single pipeline run from api/v1/datamodels/metrics */
export interface DatamodelMetricRun {
  pipeline_run_id: string;
  pipeline_trigger_time: string;
  status: string;
  records_processed: number;
  data_quality_issues: number;
  schema_drift_events: number;
  records_parsed_size_MB: number;
  schema_compliance: number;
  unique_message_ids: number | null;
  total_claims_ingested: number;
  total_quality_issues: number;
  total_schema_drifts: number;
  total_data_volume_mb: number;
  total_runs: number;
}

/** Response data from api/v1/datamodels/metrics */
export interface DatamodelsMetricsResponseData {
  metrics: DatamodelMetricRun[];
  count: number;
  days: number;
  category: string;
}

/** Full API response for api/v1/datamodels/metrics */
export interface DatamodelsMetricsApiResponse {
  status_code: number;
  message: string;
  data: DatamodelsMetricsResponseData;
}

/** Params for getDatamodelsMetrics */
export interface GetDatamodelsMetricsParams {
  days?: number;
  start_date?: string;
  end_date?: string;
  category: string;
}

export const datamodelsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getDatamodels: builder.query<DatamodelsApiResponse, void>({
      query: () => ({
        url: apiEndPoints.getDatamodels,
        method: 'GET',
      }),
      transformErrorResponse: handleErrorResponse,
    }),
    getDatamodelsMetrics: builder.query<DatamodelsMetricsApiResponse, GetDatamodelsMetricsParams>({
      query: ({ days, start_date, end_date, category }) => ({
        url: apiEndPoints.getDatamodelsMetrics,
        body: {
          ...(days != null ? { days } : {}),
          ...(start_date ? { start_date } : {}),
          ...(end_date ? { end_date } : {}),
          category,
        },
        method: 'POST',
      }),
      transformErrorResponse: handleErrorResponse,
    }),
  }),
});

export const { useGetDatamodelsQuery, useGetDatamodelsMetricsQuery } = datamodelsApiSlice;
